module.exports = __webpack_public_path__ + "static/media/fdi-leaflet.ddcc7128.pdf";